import ReportDtManager from './ReportDtManager';

export const reportDtFactory = (processType, filters, context) => {
  const handleReport = new ReportDtManager(filters, processType, {}, context);

  return handleReport.buildQueryParams();
};
